import { createStore } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

import rootReducer from "./index";

const persistConfig = {
  key: "root",
  blacklist: [
    "imageTimelineReducer",
    "rxWriterReducer",
    "recommendationRulesReducer"
  ],
  storage
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
let store = createStore(persistedReducer);
let persistor = persistStore(store);
export { store, persistor };
